import request from "../request";
import { BIZ_DATA_PREFIX } from "./prefix";

/**
 * @desc 获取系统指定词条的多语言。
 */
export const queryI18nSysList = (data = {}): any => {
  return request({
    url: `/api${BIZ_DATA_PREFIX}/query/i18n/sys/list`,
    method: "post",
    data,
  });
};

/**
 * @desc 获取系统指定词条的多语言。
 */
export const queryI18nSysTags = (params = {}): any => {
  return request({
    url: `/api${BIZ_DATA_PREFIX}/query/i18n/sys/tags`,
    method: "get",
    params,
  });
};


/**
 * @desc 获取系统支持的语言列表.
 */
export const queryI18nLanguageSupport = (params = {}): any => {
  return request({
    url: `/api${BIZ_DATA_PREFIX}/query/i18n/language/support`,
    method: "get",
    params,
  });
};
